import { client } from '../lib/client';

// 관리자 API(/v1/admin/*) — 회원 role 'admin' 토큰 필요. 배너 이미지는 multipart(FormData)
const call = (url, options = {}) => client({ url: `/v1/admin${url}`, ...options }, true);

export const adminSummaryAPI = () => call('/summary');

export const adminNoticeAPI = () => call('/notice');
export const adminNoticeSaveAPI = (data) => call('/notice', { method: 'put', data });

export const adminBannersAPI = () => call('/banners');
export const adminBannerCreateAPI = (formData) => call('/banners', { method: 'post', data: formData, file: true });
export const adminBannerUpdateAPI = (id, formData) => call(`/banners/${id}`, { method: 'put', data: formData, file: true });
export const adminBannerDeleteAPI = (id) => call(`/banners/${id}`, { method: 'delete' });

export const adminFaresAPI = (params) => call('/fares', { params });
export const adminFareCreateAPI = (data) => call('/fares', { method: 'post', data });
export const adminFareUpdateAPI = (id, data) => call(`/fares/${id}`, { method: 'put', data });
export const adminFareDeleteAPI = (id) => call(`/fares/${id}`, { method: 'delete' });
export const adminFareSettingsAPI = () => call('/fare-settings');
export const adminFareSettingsSaveAPI = (data) => call('/fare-settings', { method: 'put', data });

export const adminMembersAPI = (params) => call('/members', { params });
export const adminMemberUpdateAPI = (id, data) => call(`/members/${id}`, { method: 'put', data });

export const adminOrdersAPI = (params) => call('/orders', { params });

export const adminClientsAPI = (q) => call('/clients', { params: q ? { q } : undefined });
export const adminMemberMileageAPI = (id) => call(`/members/${id}/mileage`);
export const adminMemberMileageAdjustAPI = (id, data) => call(`/members/${id}/mileage`, { method: 'post', data });

// 운임 관리 — 퀴노스메인과 같은 데이터(기본 운임표·거래처 운임표·차량 규칙·조회)
export const fareBaseAPI = () => call('/fare-rates/base');
export const fareBaseSaveAPI = (rates) => call('/fare-rates/base', { method: 'put', data: { rates } });
export const fareClientAPI = (clientKey) => call(`/fare-rates/client/${encodeURIComponent(clientKey)}`);
export const fareClientSaveAPI = (clientKey, rates) => call(`/fare-rates/client/${encodeURIComponent(clientKey)}`, { method: 'put', data: { rates } });
export const fareConfigAPI = (owner) => call(`/fare-rates/config/${encodeURIComponent(owner)}`);
export const fareConfigSaveAPI = (owner, config) => call(`/fare-rates/config/${encodeURIComponent(owner)}`, { method: 'put', data: config });
export const fareLookupAPI = (params) => call('/fare-rates/lookup', { params });
